import React from "react";

interface BynIconProps {
  className?: string;
}

export const BynIcon: React.FC<BynIconProps> = ({ className }) => {
  return (
    <i
      className={`nbrb-icon byn-icon${className ? ` ${className}` : ""}`}
      aria-hidden="true"
    >
      BYN
    </i>
  );
};
